import type { FetchCountriesArgs } from '../../api/types/user.types';

import { queryKeys } from '../../queryKeys';
import { useInfiniteQuery } from '../base';

export default function useInfiniteCountries(
  filters: FetchCountriesArgs['filters'],
  enabled = true,
) {
  const { queryFn, queryKey } = queryKeys.users.fetchInfiniteCountries({
    filters,
  });
  return useInfiniteQuery({
    enabled,
    initialPageParam: '1',
    meta: {
      limit: filters?.limit ?? '25',
    },
    queryFn: async (context: any) => {
      return queryFn({ ...context, queryKey });
    },
    queryKey,
  });
}
